import Vue          from 'vue';
import axios        from 'axios';
import moment       from 'moment';
import api          from '@/service';
import qs           from 'query-string';
import store        from '@/vuex/store';
import SDLUtil      from '@/utils/SDLUtil';
import StringUtil   from '@/utils/StringUtil';

require('moment-jdateformatparser');

const getUserInfo = (loginId, loginPwd, loginSystem, loginType, loadMenuKind) => axios.get(
    `${SDLUtil.API_URL}/noauth/login/getSkpUserInfo.skp?`
  + `userId=${loginId}`
  + `&userPwd=${loginPwd}`
  + `&loginSystem=${loginSystem}`
  + `&loginType=${loginType}`
  + `&loadMenuKind=${loadMenuKind}`
);
const getEpTrayUserInfo = loginForm => axios.post( `${SDLUtil.API_URL}/noauth/login/getEpTrayUserInfo.skp`, loginForm );

const changeSubsidiaryAndReLogin = reLoginform => axios.post(
    `${SDLUtil.API_URL}/basis/login/changeSubsidiary.skp`,
    qs.stringify(reLoginform),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

const refreshJwtToken = () => axios.post(`${SDLUtil.API_URL}/basis/common/refreshToken.skp`);

const setHeaderToken = token => {
    axios.defaults.headers.common['x-auth-token'] = token;
};

export default {
    // DirectLogin service
    async directLogin(loginId, loginPwd, loginSystem, loginType, loadMenuKind) {
        try {
            const response = await getUserInfo(loginId, loginPwd, loginSystem, loginType, loadMenuKind);
            let userData = response.data;
            let userInfo = JSON.parse(response.data.userInfo);
            userInfo.userToken = userData.jwttoken;

            if(StringUtil.strToBool(userInfo.isLogin)) {
                this.setUserInfo(userData.jwttoken);
                store.commit('SESSION_ID', userInfo.sessionId);
                delete userInfo.sessionId;

                return Object.assign(userInfo, { code: 'authOk' });

            } else {
                return Object.assign(userInfo, { code: 'authFail' });
            }


        } catch (err) {
            return Object.assign(err, { code: 'error' });
        }
    },
    // TODO: epTray login service.
    async loginEpTray(epTrayKey) {
        try {
            const formData = new FormData();
            formData.append('ssoData', epTrayKey);
            const userInfoResponse = await getEpTrayUserInfo(formData);
            this.setToken(userInfoResponse.data.jwtToken);
            return Object.assign(userInfoResponse.data, { code: 'authOk' });

        } catch (err) {
            // Vue.$log.error('login:', err);
            return err.data.error;
        }
    },
    // SCMS, GSPN login service
    setLoginFromOtherSystem(res) {
        let userData = res.data;
        let userInfo = {};
        try {
            userInfo = JSON.parse(userData.userInfo);
        } catch(e) {
            userInfo = { isLogin: false, isReg: userData.isReg };
        }

        Vue.$log.info('setLoginFromOtherSystem userInfo =>', userInfo);
        if(StringUtil.strToBool(userInfo.isLogin)) {
            userInfo.userToken = userData.jwttoken;
            this.setUserInfo(userData.jwttoken);
            store.commit('SESSION_ID', userInfo.sessionId);
            delete userInfo.sessionId;
            return Object.assign(userInfo, { code: 'authOk' });

        } else {
            // 사용자 등록이 필요한 경우
            if(userInfo.isReg) {
                console.log('request for auth =>', userData.userInfo);
                alert('Registration page will open. Please be patient. This might take a while.');
                store.commit('REG_PARAMS', { encUserInfo: userData.userInfo });
                document.location = `${SDLUtil.WEB_CONTEXT_PATH}/registerAccess`;

            } else {
                return Object.assign({}, { code: 'authFail' });
            };
        }
    },
    // CSP login service
    setLoginFromOtherSystemCSP(res) {
        let userData = res.data;
        let userInfo = {};
        try {
            userInfo = JSON.parse(userData.userInfo);
        } catch(e) {
            userInfo = { isLogin: false, isReg: userData.isReg };
        }

        Vue.$log.info('setLoginFromOtherSystemCSP userInfo =>', userInfo);
        if(StringUtil.strToBool(userInfo.isLogin)) {
            userInfo.userToken = userData.jwttoken;
            this.setUserInfo(userData.jwttoken);
            store.commit('SESSION_ID', userInfo.sessionId);
            delete userInfo.sessionId;
            return Object.assign(userInfo, { code: 'authOk' });

        } else {
            // 사용자 등록이 필요한 경우
            if(userInfo.isReg) {
                console.log('request for auth =>', userData.userInfo);
                alert('Registration page will open. Please be patient. This might take a while.');
                store.commit('REG_PARAMS', { encUserInfo: userData.userInfo });
                document.location = `${SDLUtil.WEB_CONTEXT_PATH}/registerAccessCSP`;

            } else {
                return Object.assign({}, { code: 'authFail' });
            };
        }
    },
    // Footer 법인 변경
    async changeSubsidiary(topRhqCd, topRhqNm, topSubsidiaryCd, topSubsidiaryNm, chgLoginSystem) {
        try {
            const loginSystem = chgLoginSystem || store.getters.getLoginSystem || '';
            const formData = {
                topRhqCd : topRhqCd,
                topRhqNm : topRhqNm,
                topSubsidiaryCd : topSubsidiaryCd,
                topSubsidiaryNm : topSubsidiaryNm,
                loginSystem : loginSystem,
                loadMenuKind : (loginSystem === 'SUPPORT') ? 'SUP' : 'ALL',
            };

            const response = await changeSubsidiaryAndReLogin(formData);
            let userData = response.data;
            let userInfo = JSON.parse(response.data.userInfo);
            userInfo.userToken = userData.jwttoken;

            this.setUserInfo(userData.jwttoken);
            store.commit('SESSION_ID', userInfo.sessionId);
            delete userInfo.sessionId;

            return Object.assign(userInfo, { code: 'authOk' });

        } catch (err) {
            return err.data.error;
        }
    },
    // TODO: Token refresh service
    async refreshToken() {
        return await refreshJwtToken()
            .then(res => {
                this.setUserInfo(res.jwttoken);
            })
            .catch(err => {
                Vue.$log.error('※ skpLoginService refreshToken error => ', err);
                this.logout();
            });
    },
    // Logout service
    logout() {
        Vue.$log.info("※ skpLoginService logout method");
        this.setUserInfo('');
    },
    async codeList(v) {
        return await api.getComboList(v, 'CORP_CD', '');
    },
    async setUserInfo(userToken) {
        console.log('MAti.userToken ==> ', userToken);
        if (StringUtil.isNull(userToken)) {
            return axios.get(`${SDLUtil.API_URL}/basis/logout.skp`)
                .then((res) => {
                    //localStorage.setItem('adminToken', '');
                    axios.defaults.headers.common['original-user-id'] = '';
                    setHeaderToken('');
                    localStorage.clear();
                    // TODO parking page 이동
                    // document.location = `${SDLUtil.WEB_CONTEXT_PATH}/`;
                })
                .catch(err => {
                    Vue.$log.error('※ skpLoginService logout error => ', err);
                    //localStorage.setItem('adminToken', '');
                    axios.defaults.headers.common['original-user-id'] = '';
                    setHeaderToken('');
                    localStorage.clear();
                    // No auth page 이동
                    // document.location = `${SDLUtil.WEB_CONTEXT_PATH}/no_auth`;
                });

        } else {
            setHeaderToken(userToken);
            let loginUser = SDLUtil.parseJwt(userToken);
            let momentFormat = moment().toMomentFormatString(loginUser.dateFormat) || '';

            /*
            if (StringUtil.isNull(loginUser.companyName) && !StringUtil.isNull(loginUser.companyCode)) {
                const codeResp = await this.codeList(loginUser.companyCode);
                const idx = codeResp.findIndex(function (item) { return item.code === loginUser.companyCode; });
                if (-1 < idx)  loginUser.companyName =  codeResp[idx].codeName;
            }
            */

            //console.log('MAti.loginUser ==> ', loginUser);
            localStorage.setItem('user',        loginUser.loginId);
            localStorage.setItem('language',    loginUser.locale);
            localStorage.setItem('listRows',    loginUser.listRows);
            localStorage.setItem('device',      loginUser.device);
            localStorage.setItem('mDateFormat', momentFormat);
            localStorage.setItem('dateFormat',  loginUser.dateFormat);
            localStorage.setItem('timeFormat',  loginUser.timeFormat);
            localStorage.setItem('timeZone',    loginUser.timeZone);

            // 주요정보 vuex 로 추가 후 삭제
            store.commit('LOGIN_NO',        loginUser.loginNo);         delete loginUser.loginNo;
            store.commit('LOGIN_RHQ',       loginUser.loginRHQ);        delete loginUser.loginRHQ;
            store.commit('LOGIN_SYSTEM',    loginUser.loginSystem);     delete loginUser.loginSystem;
            store.commit('CORP_CD',         loginUser.companyCode);     delete loginUser.companyCode;
            store.commit('ROLES',           loginUser.corpUserRole);    delete loginUser.corpUserRole;
            store.commit('DEPT_NO',         loginUser.deptNo);          delete loginUser.deptNo;
            store.commit('DEPT_LEVEL_CD',   loginUser.deptLevelCd);     delete loginUser.deptLevelCd;
            store.commit('SUPER_USER_YN',   loginUser.superUserYn);     delete loginUser.superUserYn;

            // Other System connection
            const otherSystem = StringUtil.nvl(loginUser.connSystem);
            // SCMS에서 접속한 경우
            if(otherSystem === 'SCMS') {
                Vue.$log.info("※ skpLoginService Other system connection ->", otherSystem,
                                                              "/ loginUser: ", loginUser.loginId || '['+ loginUser.loginNo +']');
                const cttType = StringUtil.nvl(loginUser.cttType);
                if(!StringUtil.isNull(cttType)) {
                    let popupParams = {
                        cttType         : cttType,
                        scmsModelCd     : StringUtil.nvl(loginUser.modelCd),
                        scmsModelGbmCd  : StringUtil.nvl(loginUser.modelGbmCd),
                        scmsEcnNo       : StringUtil.nvl(loginUser.ecnNo),
                        boardType1      : StringUtil.nvl(loginUser.boardType1),
                        boardType2      : StringUtil.nvl(loginUser.boardType2),
                        categoryCd1     : StringUtil.nvl(loginUser.categoryCd1),
                        categoryCd2     : StringUtil.nvl(loginUser.categoryCd2),
                        categoryCd3     : StringUtil.nvl(loginUser.categoryCd3),
                        knowledgeId     : StringUtil.nvl(loginUser.knowledgeId),
                    };

                    store.commit('CONN_SYSTEM',  otherSystem);  delete loginUser.connSystem;
                    store.commit('POPUP_PARAMS', popupParams);  delete loginUser.cttType;
                                                                delete loginUser.modelCd;
                                                                delete loginUser.modelGbmCd;
                                                                delete loginUser.ecnNo;
                                                                delete loginUser.boardType1;
                                                                delete loginUser.boardType2;
                                                                delete loginUser.categoryCd1;
                                                                delete loginUser.categoryCd2;
                                                                delete loginUser.categoryCd3;
                                                                delete loginUser.knowledgeId;
                };

            // GSPN에서 접속한 경우
            } else if(otherSystem === 'GSPN') {
                Vue.$log.info("※ skpLoginService Other system connection ->", otherSystem);

                // GSPN Common Connection -> viewName, modelCode
                let popupParams = {};
                const viewName = StringUtil.nvl(loginUser.viewName);
                if(!StringUtil.isNull(viewName)) {
                    popupParams = {
                        viewName        : StringUtil.nvl(loginUser.viewName),
                        modelCode       : StringUtil.nvl(loginUser.modelCode),
                        knowledgeId     : StringUtil.nvl(loginUser.knowledgeId),
                        boardId         : StringUtil.nvl(loginUser.boardId),
                    };
                };

                store.commit('CONN_SYSTEM', otherSystem);   delete loginUser.connSystem;
                store.commit('POPUP_PARAMS', popupParams);  delete loginUser.viewName;
                                                            delete loginUser.modelCode;
                                                            delete loginUser.knowledgeId;
                                                            delete loginUser.boardId;
            // Others
            } else {
                Vue.$log.info("※ skpLoginService Other system connection ->", otherSystem);
                store.commit('CONN_SYSTEM', otherSystem);   delete loginUser.connSystem;
            }

            localStorage.setItem('loginUser', JSON.stringify(loginUser));

            const defaultLang = (loginUser.locale || window.navigator.userLanguage || window.navigator.language || 'ko-KR').replace('-', '_').split('_')[0];
            SDLUtil.setI18nLanguage(defaultLang); // Change to language setting of login user
        }
    },
};



// WEBPACK FOOTER //
// ./src/service/skpLoginService.js